/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'
export type SystemComponentsCardVehicleFragment = {
  __typename?: 'Vehicle'
  id: string
  vehicleStatusTelemetry?: {
    __typename?: 'VehicleStatusVehicleTelemetry'
    vmcConnectionStatus: {
      __typename?: 'VehicleStatusConnectionSignal'
      connected: boolean
      updatedAt: string
    } | null
    signalConnectivity: {
      __typename?: 'VehicleStatusBooleanSignal'
      value: boolean
      updatedAt: string
    } | null
    cabinConnectivity: {
      __typename?: 'VehicleStatusCabinConnectivitySignal'
      connectivityState: boolean
      updatedAt: string
    } | null
  } | null
}

export const SystemComponentsCardVehicleFragmentDoc = gql`
    fragment SystemComponentsCardVehicle on Vehicle {
  id
  vehicleStatusTelemetry @include(if: $withAdTelemetryData) {
    vmcConnectionStatus {
      connected
      updatedAt
    }
    signalConnectivity {
      value
      updatedAt
    }
    cabinConnectivity {
      connectivityState
      updatedAt
    }
  }
}
    `
